import React, { useState, useEffect } from "react"
import ReactDOM from "react-dom"
import TopBar from "../../helpers/TopBar"

declare var root: any

var header = document.getElementById("header")

const Headeris = () => {

  return (
    <>
      <TopBar />
    </>
  )
}

if (header) {
  ReactDOM.render(<Headeris />, header)
}
